/* tslint:disable */
/* eslint-disable */
/**
 * Oasisscan API
 * https://github.com/bitcat365/oasisscan-backend#readme https://api.oasisscan.com/mainnet/swagger-ui/#/ https://api.oasisscan.com/mainnet/v2/api-docs 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidatorRow,
    ValidatorRowFromJSON,
    ValidatorRowFromJSONTyped,
    ValidatorRowToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse2001Data
 */
export interface InlineResponse2001Data {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2001Data
     */
    active: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2001Data
     */
    delegators: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2001Data
     */
    inactive: number;
    /**
     * 
     * @type {Array<ValidatorRow>}
     * @memberof InlineResponse2001Data
     */
    list: Array<ValidatorRow>;
}

export function InlineResponse2001DataFromJSON(json: any): InlineResponse2001Data {
    return InlineResponse2001DataFromJSONTyped(json, false);
}

export function InlineResponse2001DataFromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse2001Data {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': json['active'],
        'delegators': json['delegators'],
        'inactive': json['inactive'],
        'list': ((json['list'] as Array<any>).map(ValidatorRowFromJSON)),
    };
}

export function InlineResponse2001DataToJSON(value?: InlineResponse2001Data | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'delegators': value.delegators,
        'inactive': value.inactive,
        'list': ((value.list as Array<any>).map(ValidatorRowToJSON)),
    };
}


